<script lang="ts" setup>
const { t } = useI18n()
const itemStore = useItemStore()
const { send } = useWhatsappMessage()
const { metaEvent, event } = useEvent()

const redirect = () => {
  if (itemStore.currentItem?.id) {
    useItemRedirect(itemStore.currentItem)
    return
  }

  metaEvent('Contact')
  event('generate_lead')
  event('working_lead', {
    lead_status: 'Started conversations',
  })

  send(t('pages.productIndex.whatsappMessage'), false)
}
</script>

<template>
  <button
    class="fixed bottom-4 right-4 z-20 h-14 w-14 rounded-full bg-whatsapp p-[10px] text-white shadow-top-md"
    @click="redirect"
  >
    <RIcon name="mdi:whatsapp" size="38" />
  </button>
</template>
